import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/membros/validacao")({
  head: () => ({ meta: [{ title: "Validação em 7 dias — Projeto 101" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: ValidationPage,
});

const days = [
  { d: "Dia 1", t: "Defina a ideia e o cliente", desc: "Escreva em 3 frases o que você vai oferecer e para quem." },
  { d: "Dia 2", t: "Pesquise concorrentes locais", desc: "Liste 5 pessoas ou empresas que já fazem algo parecido." },
  { d: "Dia 3", t: "Fale com 5 clientes potenciais", desc: "Pergunte se pagariam pelo serviço, quanto, e por quê." },
  { d: "Dia 4", t: "Monte um preço-teste", desc: "Defina um valor inicial com margem simples." },
  { d: "Dia 5", t: "Faça a primeira oferta", desc: "Ofereça para 3 pessoas próximas com desconto de portfólio." },
  { d: "Dia 6", t: "Entregue o primeiro serviço", desc: "Registre antes e depois. Anote tempo e custos reais." },
  { d: "Dia 7", t: "Revise e decida", desc: "Compare o resultado com sua expectativa e ajuste o próximo passo." },
];

function ValidationPage() {
  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <div>
        <h1 className="font-display text-3xl font-extrabold">Checklist de Validação em 7 dias</h1>
        <p className="mt-1 text-sm text-[var(--gray-ink)]">
          Um roteiro dia a dia para sair da ideia e testar sua proposta em uma semana.{" "}
          <em>[Conteúdo demonstrativo — versão final em breve.]</em>
        </p>
      </div>
      <ol className="space-y-3">
        {days.map((x) => (
          <li key={x.d} className="rounded-2xl border border-black/5 bg-white p-5">
            <p className="text-xs font-semibold uppercase tracking-wide text-[var(--green)]">{x.d}</p>
            <h3 className="mt-1 font-display text-lg font-extrabold">{x.t}</h3>
            <p className="mt-1 text-sm text-[var(--gray-ink)]">{x.desc}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}
